import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import axios from "axios";
import { apiKey } from "../../../config/config";
import MessageCard from "../../../components/AdminCards/MessageCard";
import { FaEye, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { languageHelper } from "../../../config/helperFunctions";

function Return() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const defaultLang = localStorage.getItem("rms-lang") || "text_en";
  const columns = [
    {
      header: languageHelper(defaultLang, "SN") || "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper(defaultLang, "Reference No") || "Reference No",
      accessorKey: "ref_no",
    },
    {
      header: languageHelper(defaultLang, "Date") || "Date",
      accessorKey: "date_time",
    },
    {
      header: languageHelper(defaultLang, "Description") || "Description",
      accessorKey: "description",
    },
    {
      header: languageHelper(defaultLang, "Vat") || "Vat",
      accessorKey: "return_vat",
    },
    {
      header: languageHelper(defaultLang, "Price") || "Price",
      accessorKey: "return_amount",
    },
    {
      header: languageHelper(defaultLang, "Total") || "Total",
      accessorKey: "total_return_amount",
    },
    {
      header: languageHelper(defaultLang, "Added By") || "Added By",
      accessorKey: "user",
      cell: (user) => user.getValue().name,
    },
    {
      header: languageHelper(defaultLang, "Actions") || "Actions",
      accessorKey: "total",
      cell: (row) => (
        <Dropdown options={dropdownOptions} id={row.row.original.id} />
      ),
    },
  ];
  const [error, setError] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [data, setData] = useState([]);
  const [buttonData] = useState([
    {
      buttonText: languageHelper(defaultLang, "Add Return"),
      path: "addReturn",
    },
  ]);

  const navigate = useNavigate();

  const fetchData = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/returns`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        setData(res.data);
        setError(false);
      })
      .catch((err) => {
        setError(err?.response?.data.message || "Error Occured");
      })
      .finally(() => setPageLoading(false));
  }, [user?.token, user?.user.outlet_id]);

  const handleNavigate = (id) => {
    navigate(`${id}`);
  };

  const handleDelete = (id) => {
    setPageLoading(true);
    axios
      .delete(`${apiKey}/api/rms/admin/returns/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        fetchData();
        toast.success(res.data.message || "Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data.message || "Error Occured", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .finally(() => setPageLoading(false));
  };

  const dropdownOptions = [
    {
      name: languageHelper(defaultLang, "View"),
      icon: <FaEye />,
      func: handleNavigate,
    },
    {
      name: languageHelper(defaultLang, "Delete"),
      icon: <FaTrash />,
      func: handleDelete,
    },
  ];

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={languageHelper(defaultLang, "All Return")}
        buttonData={buttonData}
      />
    </main>
  );
}

export default Return;
